import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useFetchAllMembers from 'src/Hooks/Queries/useFetchAllMembers';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import { PhotoAlbumItem } from './PhotoAlbumItem';
import styles from './PhotoAlbums.module.scss';

const PhotoAlbums = () => {
  const { t } = useTranslation();
  const { data: currentUser } = useFetchUser();
  const { data: membersData } = useFetchAllMembers();

  const allMembers = useMemo(() => {
    const members = membersData?.members ?? [];

    if (!currentUser) return members;

    // Add current user at the beginning if not already in the list
    const isCurrentUserInList = members.some(m => m.user?.id === currentUser.id);
    if (isCurrentUserInList) return members;

    return [
      {
        user: {
          id: currentUser.id,
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          profilePictureUrl: currentUser.profilePictureUrl,
        },
      },
      ...members,
    ];
  }, [currentUser, membersData]);

  const items = allMembers
    .filter(m => m.user?.firstName && m.user?.lastName)
    .map(m => (
      <PhotoAlbumItem
        key={m.user!.id}
        memberId={m.user!.id}
        firstName={m.user!.firstName!}
        lastName={m.user!.lastName!}
        profilePictureUrl={m.user!.profilePictureUrl}
      />
    ));

  return (
    <div className={styles.box}>
      <span className={styles.title}>{t('community.photoAlbums', 'Photos par personne')}</span>

      {items.length > 0 ? (
        <div className={styles.items}>{items}</div>
      ) : (
        <span className={styles.empty}>
          {t('community.noPhotoAlbums', 'Aucun album photo pour le moment')}
        </span>
      )}
    </div>
  );
};

export default PhotoAlbums;
